import { useEffect, useState } from 'react';
import { Box, Modal } from '@mui/material';
import { useNavigate } from 'react-router';
import { useQuery } from '@apollo/client';

import { QUERY_LICENSE } from '../graphql/license';
import { LoadingComponent } from './LoadingScreen';
import LicenseForm from './LicenseForm';
import { PATH_PAGE } from '../routes/paths';
import useRedux from '../hooks/useRedux';

export default function LicenseHandler() {
  const navigate = useNavigate();
  const { setLicenseCode } = useRedux();

  // ---------------------
  const { data, loading, error } = useQuery(QUERY_LICENSE, {
    pollInterval: 60 * 1000, // Refetch the query every 1 minute
  });

  // ---------------------
  const [openModal, setOpenModal] = useState(false);

  // ---------------------
  useEffect(() => {
    if(error)
    {
      const token = localStorage.getItem('SESSION_ID');
      if(token){
        return;
      }
    }
    if (!error && data?.license?.checkActivation) {
      const { Activated, SessionId, AvailableToTransfer, LicenseCode } = data.license.checkActivation;

      if (Activated) {
        localStorage.setItem('SESSION_ID', SessionId);
        setLicenseCode(LicenseCode);
      }
      // redirect to transfer
      else if (AvailableToTransfer && LicenseCode) {
        navigate(PATH_PAGE.availableToTransfer(LicenseCode));
      } else {
        setLicenseCode(null);
        setOpenModal(true);
      }
    }
  }, [data, error]);

  // ---------------------
  if (loading) {
    return <LoadingComponent />;
  }

  // ---------------------
  return (
    <Modal open={openModal} onClose={null} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
        }}
      >
        <LicenseForm onSuccess={() => setOpenModal(false)} />
      </Box>
    </Modal>
  );
}
